import React, { useEffect, useState } from "react";
import { CircleMarker, Popup } from "react-leaflet";
import { fetchStreamGauges } from "../../lib/api";

const TREND_META = {
  spiking: { color: "#E63946", label: "SPIKING", r: 8 },
  rising: { color: "#F59E0B", label: "Rising", r: 6 },
  steady: { color: "#4A9BD1", label: "Steady", r: 5 },
};

export default function StreamGaugesLayer() {
  const [gauges, setGauges] = useState([]);

  useEffect(() => {
    const load = () =>
      fetchStreamGauges().then((d) => setGauges(d.gauges || [])).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      {gauges.map((g) => {
        const m = TREND_META[g.trend] || TREND_META.steady;
        return (
          <CircleMarker
            key={g.site_no}
            center={[g.latitude, g.longitude]}
            radius={m.r}
            pathOptions={{
              color: "#0A0D0C", weight: 1.5,
              fillColor: m.color, fillOpacity: 0.9,
            }}
          >
            <Popup>
              <div style={{ fontSize: 12, minWidth: 190 }} data-testid={`gauge-popup-${g.site_no}`}>
                <div style={{ fontWeight: 700, color: m.color }}>
                  STREAM GAUGE · {m.label.toUpperCase()}
                </div>
                <b>{g.name}</b>
                <br />
                {g.gage_height_ft != null && (
                  <>Height: {g.gage_height_ft} ft
                    {g.height_delta_4h != null && ` (${g.height_delta_4h >= 0 ? "+" : ""}${g.height_delta_4h.toFixed(2)} ft / 4h)`}
                    <br /></>
                )}
                {g.discharge_cfs != null && (
                  <>Flow: {Math.round(g.discharge_cfs)} cfs
                    {g.discharge_delta_4h != null && ` (${g.discharge_delta_4h >= 0 ? "+" : ""}${Math.round(g.discharge_delta_4h)} / 4h)`}
                    <br /></>
                )}
                {g.scar_name && <>{g.scar_dist_mi} mi from {g.scar_name} burn scar<br /></>}
                <a href={g.usgs_url} target="_blank" rel="noreferrer">USGS live data ↗</a>
              </div>
            </Popup>
          </CircleMarker>
        );
      })}
    </>
  );
}
